export const ON_INITIAL_STATE = 'ON_INITIAL_STATE';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_CURRENT_VIEW = 'SET_CURRENT_VIEW';